(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portada"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRail(sec) {
    var rail = sec.querySelector('[data-rcp-rail]');
    if (!rail || rail.dataset.ready) return;
    rail.dataset.ready = '1';
    var nav = sec.querySelector('.rcp-nav'), dotsBox = sec.querySelector('.rcp-dots');
    var arrows = sec.querySelectorAll('.rcp-arrow');
    var slides = rail.querySelectorAll('.rcp-step');
    var pages = 1, index = 0;
    function step() { return slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : rail.clientWidth; }
    function perView() { return Math.max(1, Math.round((rail.clientWidth - parseFloat(getComputedStyle(rail).paddingLeft) * 2 + 20) / step())); }
    function build() {
      pages = Math.max(1, slides.length - perView() + 1);
      nav.hidden = pages <= 1;
      dotsBox.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'rcp-dot'; d.setAttribute('aria-label', 'Ir al paso ' + (i + 1));
        d.addEventListener('click', (function (k) { return function () { go(k); }; })(i));
        dotsBox.appendChild(d);
      }
      update();
    }
    function update() {
      index = Math.min(pages - 1, Math.round(rail.scrollLeft / step()));
      Array.prototype.forEach.call(dotsBox.children, function (d, i) { d.classList.toggle('is-active', i === index); });
      arrows[0].disabled = index <= 0;
      arrows[1].disabled = index >= pages - 1;
    }
    function go(i) { i = Math.max(0, Math.min(pages - 1, i)); rail.scrollTo({ left: i * step() }); }
    arrows.forEach(function (b) { b.addEventListener('click', function () { go(index + (+b.dataset.dir)); }); });
    var t; rail.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', build);
    build();
  }
  function initAll(root) { (root || document).querySelectorAll('.rcp-steps').forEach(initRail); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recov-carousel')) {
    customElements.define('recov-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.recov-testi__track');
        this.slides = Array.from(this.track.children);
        this.controls = this.querySelector('.recov-testi__controls');
        this.dotsBox = this.querySelector('.recov-testi__dots');
        this.arrows = this.querySelectorAll('.recov-testi__arrow');
        this.arrows.forEach((btn) => {
          btn.addEventListener('click', () => this.goTo(this.index + Number(btn.dataset.dir)));
        });
        this.track.addEventListener('scroll', () => {
          window.cancelAnimationFrame(this.raf);
          this.raf = window.requestAnimationFrame(() => this.update());
        });
        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this.track);
        this.build();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      step() {
        if (this.slides.length < 2) return this.track.clientWidth;
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      }

      build() {
        if (!this.slides.length) return;
        const perView = Math.max(1, Math.round((this.track.clientWidth + 1) / this.step()));
        this.pages = Math.max(1, this.slides.length - perView + 1);
        this.controls.hidden = this.pages <= 1;
        this.dotsBox.innerHTML = '';
        for (let i = 0; i < this.pages; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'recov-testi__dot';
          dot.setAttribute('aria-label', 'Ir a la opinion ' + (i + 1));
          dot.addEventListener('click', () => this.goTo(i));
          this.dotsBox.appendChild(dot);
        }
        this.update();
      }

      update() {
        this.index = Math.min(this.pages - 1, Math.round(this.track.scrollLeft / this.step()));
        Array.from(this.dotsBox.children).forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
        this.arrows[0].disabled = this.index <= 0;
        this.arrows[1].disabled = this.index >= this.pages - 1;
      }

      goTo(i) {
        const target = Math.max(0, Math.min(this.pages - 1, i));
        this.track.scrollTo({ left: target * this.step() });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
